import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "reactstrap";
import { languageOptions, relationShipOptions, formikAddEmergencyContactPatient} from "../Constant";
import { updatePatientById } from "../../../api/patient";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import TextInput from "../../../components/InputFields/TextInput";
import { failed, success } from "../../../utils/Tostify";
import Loader from "../../../components/Loader/Loader";
import MultiSelect from "../../../components/InputFields/MultiSelect";
import { useNavigate } from "react-router";

const AddEmergencyContact = ({toggleTab, patientDeatils}) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  let token = useSelector(state => state.userReducer.token);
  const navigate = useNavigate();

  const formik = useFormik({
    ...formikAddEmergencyContactPatient,
    onSubmit: async (values) => {
      const cleanedValues = {
        ...values,
        languagePreference: values.languagePreference?.map(option => option.value) || [], // Extract only 'value'
        alternatelanguagePreference: values.alternatelanguagePreference?.map(option => option.value) || [] // Extract only 'value'
      };
      let payload = {
        emergencyContacts : cleanedValues
      };
      let res;
      try {
        setIsLoading(true);
        res = await updatePatientById({payload , dispatch, token , patientId: patientDeatils._id});
        if (res?.status == "SUCCESS") {
          setIsLoading(false);
          navigate("/clinic/patient-profile", { state: { patientData: patientDeatils?._id } });
          success(res?.message);
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    formik.setFieldValue(
      "preferredContactMethod",
      checked
        ? [...formik.values.preferredContactMethod, value]
        : formik.values.preferredContactMethod.filter(item => item !== value)
    );
  };

  const handleAlternateCheckboxChange = (event) => {
    const { value, checked } = event.target;
    formik.setFieldValue(
      "alternatepreferredContactMethod",
      checked
        ? [...formik.values.alternatepreferredContactMethod, value]
        : formik.values.alternatepreferredContactMethod.filter(item => item !== value)
    );
  };

  useEffect(() => {
    if (patientDeatils?.emergencyContacts) {
      const emergencyContacts = patientDeatils.emergencyContacts;
      const transformToOptionFormat = (options) => {
        if (options && options.length > 0) {
          return options.map((option) => ({
            label: option,
            value: option
          }));
        }
        return options;
      };
      formik.setValues({
        name: emergencyContacts.name || "",
        relationship: emergencyContacts.relationship || "",
        phone: emergencyContacts.phone || "",
        secondaryPhone: emergencyContacts.secondaryPhone || "",
        email: emergencyContacts.email || "",
        languagePreference: transformToOptionFormat(emergencyContacts.languagePreference  || []),
        preferredContactMethod: emergencyContacts.preferredContactMethod || [],
        alternateName: emergencyContacts.alternateName || "",
        alternateReln: emergencyContacts.alternateReln || "",
        alternatePhone: emergencyContacts.alternatePhone || "",
        alternateSecondaryPhone: emergencyContacts.alternateSecondaryPhone || "",
        alternateEmail: emergencyContacts.alternateEmail || "",
        alternatelanguagePreference: transformToOptionFormat(emergencyContacts.alternatelanguagePreference || []),
        alternatepreferredContactMethod: emergencyContacts.alternatepreferredContactMethod || []
      });
    }
  }, [patientDeatils]);

  return (
    <div>
      {isLoading ? <Loader /> : null}
      <Form onSubmit={formik.handleSubmit}>
        <h6>Emergency Contact</h6>
        <Row>
          <Col md={6} lg={4}>
            <TextInput
              keyField={"name"}
              formik={formik}
              label="Emergency Contact Name"
              type="text"
              value={formik.values.name}
              onChange={(e) => {
                formik.setFieldValue("name", e.target.value);
              }}
            />
          </Col>
          <Col md={6} lg={4}>
            <TextInput
              keyField={"relationship"}
              formik={formik}
              type="select"
              label="Relationship"
              placeholder="Select"
              options={relationShipOptions}
              value={formik.values.relationship}
              onChange={(e) =>
                formik.setFieldValue("relationship", e.target.value)
              }
            />
          </Col>
          <Col md={6} lg={4}>
            <TextInput
              keyField={"email"}
              formik={formik}
              label="Email"
              required={false}
              type="email"
              value={formik.values.email}
              onChange={(e) => {
                formik.setFieldValue("email", e.target.value);
              }}
            />
</Col>
          <Col md={6} lg={4}>
            <TextInput
              keyField={"phone"}
              formik={formik}
              required={false}
              label="Phone"
              type="phone"
              value={formik.values.phone}
              onChange={(e) => {
                formik.setFieldValue("phone", e);
              }}
            />
          </Col>
          <Col md={6} lg={4}>
            <TextInput
              keyField={"secondaryPhone"}
              required={false}
              formik={formik}
              label="Secondary Phone"
              type="phone"
              value={formik.values.secondaryPhone}
              onChange={(e) => {
                formik.setFieldValue("secondaryPhone", e);
              }}
            />
          </Col>
          <Col md={6} lg={4}>
            <MultiSelect
              keyField={"languagePreference"}
              formik={formik}
              required={false}
              type="select"
              label="Language Preference"
              placeholder="Select"
              options={languageOptions}
              value={formik.values.languagePreference}
              onChange={(e) =>
                formik.setFieldValue("languagePreference", e)
              }
            />
          </Col>
          <Col lg={12} className="mb-3">
            <div className="d-flex gap-2 align-items-center">
              <span className="text-nowrap">Prefered Contact Method:   </span>
                <input
                  type="checkbox"
                  required={false}
                  value="Phone"
                  checked={formik.values.preferredContactMethod.includes("Phone")}
                  onChange={handleCheckboxChange}
                />
                Phone
                <input
                  type="checkbox"
                  value="Text"
                  checked={formik.values.preferredContactMethod.includes("Text")}
                  onChange={handleCheckboxChange}
                />
                Text
                <input
                  type="checkbox"
                  value="Email"
                  required={false}
                  checked={formik.values.preferredContactMethod.includes("Email")}
                  onChange={handleCheckboxChange}
                />
                Email
            </div>
          </Col>
        </Row>
        <h6>Alternative Emergency Contact</h6>
        <Row>
          <Col md={6} lg={4}>
            <TextInput
              keyField={"alternateName"}
              formik={formik}
              required={false}
              label="Alternate Emergency Contact Name"
              type="text"
              value={formik.values.alternateName}
              onChange={(e) => {
                formik.setFieldValue("alternateName", e.target.value);
              }}
            />
          </Col>
          <Col md={6} lg={4}>
            <TextInput
              keyField={"alternateReln"}
              formik={formik}
              type="select"
              required={false}
              label="Relationship"
              placeholder="Select"
              options={relationShipOptions}
              value={formik.values.alternateReln}
              onChange={(e) =>
                formik.setFieldValue("alternateReln", e.target.value)
              }
            />
          </Col>
          <Col md={6} lg={4}>
            <TextInput
              keyField={"alternateEmail"}
              formik={formik}
              required={false}
              label="Email"
              type="email"
              value={formik.values.alternateEmail}
              onChange={(e) => {
                formik.setFieldValue("alternateEmail", e.target.value);
              }}
            />
          </Col>
          <Col md={6} lg={4}>
            <TextInput
              keyField={"alternatePhone"}
              formik={formik}
              required={false}
              label="Phone"
              type="phone"
              value={formik.values.alternatePhone}
              onChange={(e) => {
                formik.setFieldValue("alternatePhone", e);
              }}
            />
          </Col>
          <Col md={6} lg={4}>
            <TextInput
              keyField={"alternateSecondaryPhone"}
              formik={formik}
              label="Secondary Phone"
              required={false}
              type="phone"
              value={formik.values.alternateSecondaryPhone}
              onChange={(e) => {
                formik.setFieldValue("alternateSecondaryPhone", e);
              }}
            />
          </Col>
          <Col md={6} lg={4}>
            <MultiSelect
              keyField={"alternatelanguagePreference"}
              formik={formik}
              type="select"
              required={false}
              multiple={true}
              label="Language Preference"
              placeholder="Select"
              options={languageOptions}
              value={formik.values.alternatelanguagePreference}
              onChange={(e) =>
                formik.setFieldValue("alternatelanguagePreference", e)
              }
            />
          </Col>
          <Col lg={12}>
            <div className="d-flex gap-2 align-items-center">
              <span className="text-nowrap">Prefered Contact Method:   </span>
                <input
                  type="checkbox"
                  value="Phone"
                  checked={formik.values.alternatepreferredContactMethod.includes("Phone")}
                  onChange={handleAlternateCheckboxChange}
                />
                Phone
                <input
                  type="checkbox"
                  value="Text"
                  checked={formik.values.alternatepreferredContactMethod.includes("Text")}
                  onChange={handleAlternateCheckboxChange}
                />
                Text
                <input
                  type="checkbox"
                  value="Email"
                  checked={formik.values.alternatepreferredContactMethod.includes("Email")}
                  onChange={handleAlternateCheckboxChange}
                />
                Email
            </div>
          </Col>
        </Row>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <button className="save_btn" type="button" onClick={()=>{patientDeatils?._id ? navigate("/clinic/patient-profile", { state: { patientData: patientDeatils?._id } }) : navigate("/clinic/patient-list");}}>Cancel</button>
          <button className="save_btn saving" type="submit">
            Save
          </button>
        </div>
      </Form>
    </div>
  );
};

export default AddEmergencyContact;
